import axios from "../axiosPlugin.js";

export const getDailySalesReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/dailySalesReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getDailyMovieRevenueReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/dailyMovieSalesRecordReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};
export const getDailyMovieRevenueReportV2 = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/v2/dailyMovieSalesRecordReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};
export const getDailyScheduleRevenueReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/dailyScheduleRevenueReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips
    }
  });
};
export const getShopSalesReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/shopSalesReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getSoldRateReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/soldRateReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getMovieWeeklySaleReport = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/movieWeeklySalesReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getInventoryLogListService = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/inventoryLog/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const inventoryLogExport = data => {
  return axios({
    url: "/api/inventoryLog/export",
    method: "get",
    dataType: "blob",
    responseType: "blob",
    data: {
      data,
    },
  });
};

export const ticketSalesReportService = data => {
  return axios({
    url: "/api/report/ticketSalesReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const getDateListByFilmId = data => {
  return axios({
    url: "/api/report/scheduleDateListByFilmId",
    method: "get",
    data: {
      data,
    },
  });
};

export const getProductSalesReportService = data => {
  return axios({
    url: "/api/report/productSalesReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const delProductSalesReportService = data => {
  return axios({
    url: "/api/report/deleteProductSalesReportItem",
    method: "get",
    data: {
      data,
    },
  });
};

// export const getExportDailyMovieRevenueReport = data => {
//   return axios({
//     url: "/api/report/exportDailyMovieRevenueReport",
//     method: "get",
//     data: {
//       data,
//     },
//   });
// };

export const getTransactionLogList = data => {
  return axios({
    url: "/api/transactionLog/list",
    method: "get",
    data: {
      data
    },
  });
};

export const getExportDailyMovieRevenueReport = data => {
  return axios({
    url: "/api/report/exportDailyMovieRevenueReport",
    method: "get",
    responseType: "blob",
    data: {
      data
    },
  });
};

export const createTicketTransactionService = data => {
  return axios({
    url: "/api/transaction/createTicketTransaction",
    method: "post",
    data: {
      data
    },
  });
};

export const createGoodsTransactionService = data => {
  return axios({
    url: "/api/transaction/createGoodsTransaction",
    method: "post",
    data: {
      data
    },
  });
};
export const updateTicketTransactionService = data => {
  return axios({
    url: "/api/transaction/updateTicketTransaction",
    method: "post",
    data: {
      data
    },
  });
};
export const updateGoodsTransaction = data => {
  return axios({
    url: "/api/transaction/updateGoodsTransaction",
    method: "post",
    data: {
      data
    },
  });
};
export const ticketTransactionDetail = data => {
  return axios({
    url: "/api/transaction/ticketTransactionDetail",
    method: "get",
    data: { data }
  });
};
export const goodsTransactionDetail = data => {
  return axios({
    url: "/api/transaction/goodsTransactionDetail",
    method: "get",
    data: { data }
  });
};
export const getScheduleListForTransaction = data => {
  return axios({
    url: "/api/transaction/scheduleListForCreateTransaction",
    method: "get",
    data: {
      data
    },
  });
};

export const getCinemaDailyReport = data => {
  return axios({
    url: "/api/report/cinemaDailyReport",
    method: "get",
    data: { data },
  });
};

export const getTicketTypesForTransaction = data => {
  return axios({
    url: `/api/transaction/getTicketTypes/${data.scheduleId}`,
    method: "get",
    data: {},
  });
};

export const getGoodsListForTransaction = data => {
  return axios({
    url: "/api/transaction/goodsListForCreateTransaction",
    method: "get",
    data: {
      data
    },
  });
};

export const getFilmList = data => {
  return axios({
    url: "/api/film/filmListForReport",
    method: "get",
    data: {
      data
    },
  });
};

export const getDailySalesDetailList = data => {
  return axios({
    url: "/api/report/dailySalesDetailReport",
    method: "get",
    data: {
      data
    }
  });
};

export const refundTransactionTicketService = data => {
  return axios({
    url: "/api/transaction/refundTransactionTicket",
    method: "put",
    data: {
      data
    }
  });
};

export const transactionRefundCheckService = data => {
  return axios({
    url: "/api/transaction/refundTransactionCheck",
    method: "post",
    data: {
      data
    }
  });
};

export const getMemberRptListService = data => {
  return axios({
    url: "/api/cl/rpt/memberRpt-list",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipOptionListService = data => {
  return axios({
    url: "/api/cl/membership/options-list",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipFeeSalesService = data => {
  return axios({
    url: "/api/cl/rpt/memberFeeRpt-list-brand",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipFeeSalesForCinemaService = data => {
  return axios({
    url: "/api/cl/rpt/memberFeeRpt-list-cinema",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipOnlineFeeSalesService = data => {
  return axios({
    url: "/api/cl/rpt/memberFeeRpt-list-online",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipLogListForFeeService = data => {
  return axios({
    url: "/api/cl/membershipLog/list-for-fee",
    method: "get",
    data: {
      data
    }
  });
};

export const getMemberShipLogDetailService = data => {
  return axios({
    url: "/api/cl/membershipLog/fee-detail",
    method: "get",
    data: {
      data
    }
  });
};
export const refundCLFeeService = data => {
  return axios({
    url: `/api/cl/transaction/refund/${data.transactionId}?membershipLogId=${data.membershipLogId}`,
    method: "put",
    data: {}
  });
};

export const shoppingCartRefundItemsService = data => {
  return axios({
    url: "/api/transaction/shoppingCartRefundItems",
    method: "get",
    data: {
      data
    },
  });
};

export const refundMultipleCheckService = data => {
  return axios({
    url: "/api/transaction/refundMultipleCheck",
    method: "post",
    data: {
      data
    },
  });
};

export const refundMultipleTicketService = data => {
  return axios({
    url: "/api/transaction/refundMultipleTicket",
    method: "put",
    data: {
      data
    },
  });
};
